import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-third-partyApplications",
  "use": "icon-third-partyApplications-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-third-partyApplications\"><path d=\"M301.176471 141.071059a170.646588 170.646588 0 0 1 170.646588 170.646588V482.484706H301.176471a170.646588 170.646588 0 0 1 0-341.353412z m0 421.647059h170.646588v170.646588A170.706824 170.706824 0 1 1 301.176471 562.718118z m421.647058-421.647059a170.706824 170.706824 0 0 1 0 341.353412H552.176941V311.717647A170.646588 170.646588 0 0 1 722.823529 141.071059z m-170.646588 421.647059H722.823529a170.646588 170.646588 0 1 1-170.646588 170.646588V562.718118z\" fill=\"#8C8C8C\" p-id=\"1562\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/third-partyApplications.svg
// module id = 3eTw
// module chunks = 67